import { CheckCircle2, FlaskConical, Leaf, LockKeyhole, Truck } from "lucide-react";

const trustItems = [
  { icon: FlaskConical, title: "Third-party lab tested", copy: "Kratown quality standards include third-party lab testing." },
  { icon: Leaf, title: "Premium ingredients", copy: "Review package labels for product-specific ingredient information." },
  { icon: Truck, title: "Shipping made clear", copy: "Eligible shipping options appear after you enter an address." },
  { icon: LockKeyhole, title: "Secure checkout", copy: "Payment details are entered through a protected hosted payment form." },
  { icon: CheckCircle2, title: "Adult use only", copy: "Age and legal acknowledgement are required before payment." },
];

export function TrustBar() {
  return (
    <section aria-labelledby="trust-heading" className="container py-10 md:py-14">
      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-6">
        <div className="flex flex-col justify-center rounded-[1.5rem] border border-[#c2ff45]/18 bg-[#c2ff45]/[0.06] p-6">
          <p className="section-kicker text-[#d9ff8a]">Purchase with confidence</p>
          <h2 id="trust-heading" className="mt-3 font-serif text-3xl text-white">Shop with clarity.</h2>
        </div>
        {trustItems.map((item) => {
          const Icon = item.icon;
          return (
            <article key={item.title} className="edge-panel-muted rounded-[1.5rem] p-6">
              <Icon className="h-5 w-5 text-[#8beeff]" aria-hidden="true" />
              <h3 className="mt-4 text-lg font-semibold text-white">{item.title}</h3>
              <p className="mt-2 text-sm leading-7 text-white/70">{item.copy}</p>
            </article>
          );
        })}
      </div>
    </section>
  );
}
